module.exports = new __parcel__URL__("leaderboard_stardust_button_inactive.9570f962.png").toString();